import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaFileInvoice,
  FaBuilding,
  FaTags,
  FaFileAlt,
  FaUniversity,
  FaUsers,
  FaBalanceScale,
} from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";

const services = [
  {
    icon: <FaFileInvoice />,
    title: "Audit & Assurance",
    path: "/audit-assurance",
    description:
      "Comprehensive audit and assurance services in accordance with the Companies Act, 2013, Income-tax Act, 1961, and ICAI Auditing Standards. We provide independent assurance to enhance financial transparency, regulatory compliance, and stakeholder confidence.",
  },
  {
    icon: <FaBuilding />,
    title: "Taxation & Compliance",
    path: "/taxation-compliance",
    description:
      "End-to-end direct and indirect tax services under the Income-tax Act, GST laws, and allied regulations. Our approach focuses on accurate filings, timely compliance, and effective tax management for individuals and businesses.",
  },
  {
    icon: <FaTags />,
    title: "Corporate & ROC Compliances",
    path: "/corporate-compliance",
    description:
      "Complete corporate law compliance support under the Companies Act, 2013 and  regulations. We assist companies at every stage, from incorporation to ongoing statutory and regulatory compliances.",
  },
  {
    icon: <FaFileAlt />,
    title: "Business Advisory",
    path: "/business-advisory",
    description:
      "Strategic business advisory services to support growth, restructuring, and informed decision-making. We combine financial, regulatory, and  insights to help businesses operate efficiently and sustainably.",
  },
  {
    icon: <MdAccountBalance />,
    title: "Banking & Project Finance",
    path: "/banking-finance",
    description:
      "Professional assistance in banking and project finance matters in line with banking requirements. We support businesses in fund raising, financial structuring, and coordination with banks and financial institutions.",
  },
  {
    icon: <FaUniversity />,
    title: "Capital Market & SEBI",
    path: "/capital-market-sebi",
    description:
      "Specialized services for listed companies and regulated entities in compliance with SEBI regulations. We assist in regulatory audits, disclosures, and ongoing compliance within the capital market framework.",
  },
  {
    icon: <FaUsers />,
    title: "International & NRI Services",
    path: "/international-nri",
    description:
      "Advisory services for NRIs and cross-border transactions, ensuring compliance with FEMA, the Income-tax Act, and applicable DTAA provisions, along with efficient international tax planning.",
  },
  {
    icon: <FaBalanceScale />,
    title: "Outsourcing & Other Services",
    path: "/outsourcing-other",
    description:
      "Reliable professional outsourcing and specialized audit services under various Indian and foreign laws to support statutory compliance, governance, and internal control requirements.",
  },
];


export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section className="services-section">
      <h2 className="section-title">Our Services</h2>

      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={index}
            className="service-card"
            onClick={() => {
              navigate(service.path);
              window.scrollTo({ top: 0 });
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="service-header">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
            </div>

            <p className="service-desc">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
